import { Injectable } from '@angular/core';

/**
 * Replaces Ionic's Platform service with pure browser APIs.
 * Supports the same `is()` method with the same platform names.
 */
@Injectable({ providedIn: 'root' })
export class PlatformService {
  private readonly ua = navigator.userAgent || '';

  /**
   * Check if the platform matches the given name.
   * Supported names: 'ios', 'android', 'mobile', 'mobileweb', 'tablet', 'capacitor', 'desktop', 'hybrid'
   */
  public is(platformName: string): boolean {
    switch (platformName) {
      case 'ios':
        return /iPhone|iPad|iPod/i.test(this.ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      case 'android':
        return /Android/i.test(this.ua);
      case 'mobile':
        return this.is('ios') || this.is('android') || /webOS|BlackBerry|Opera Mini|IEMobile/i.test(this.ua);
      case 'mobileweb':
        return this.is('mobile') && !this.is('capacitor');
      case 'tablet':
        return this.isTablet();
      case 'capacitor':
        return !!(window as any).Capacitor?.isNativePlatform?.();
      case 'desktop':
        return !this.is('mobile');
      case 'hybrid':
        return this.is('capacitor');
      default:
        return false;
    }
  }

  private isTablet(): boolean {
    if (/iPad/i.test(this.ua)) {
      return true;
    }
    // iPad with iOS 13+ reports as Mac
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return true;
    }
    // Android tablet: Android without 'Mobile'
    if (/Android/i.test(this.ua) && !/Mobile/i.test(this.ua)) {
      return true;
    }
    return false;
  }
}
